import React from 'react'
import { observer } from 'mobx-react'
import { restaurantCenter, cartMobx } from '@mobx/mall'
import { payPlanMobx } from '@mobx/mall/payment'
import CashierController from '@ctrls/cashierController'
import { loadingLayer, modalLayer } from '@utils'
import { payOrder } from '@common/utils/payMall'
import { ConfirmModal } from '@cps'

interface IProps {
  title?: string;
}

const PayButton: React.FC<IProps> = props => {
  const history = CashierController.history()
  const isCanOrder = cartMobx.cartResult.totalCnt && payPlanMobx.canPay
  return (
    <>
      <div
        className={`cart-btn ${isCanOrder ? '' : 'disabled'}`}
        onClick={() => {
          isCanOrder && payOrder({
            history,
            handleSaveError: () => {
              modalLayer(ConfirmModal, {
                title: i18n.t('common.attention'),
                confirmText: i18n.t('cart.refreshMenu'),
                children: (<span>{i18n.t('cart.errorProduct')}</span>),
                className: 'cart-confirm-modal'
              }, 'confirmModal').then(() => {
                loadingLayer.show()
                restaurantCenter.initAll()
                setTimeout(() => loadingLayer.hide(), 2000)
              }).catch(() => {})
            }
          })
        }}
      >
        {i18n.t('pay.pay')}
      </div>
    </>
  )
}

export default observer(PayButton)
